export const otHeader = {
  TransNo: 'Request ID',
  Date: 'Request Date',
  DayStatus: 'Day Status',
  Category: 'Category',
  FromTime: 'From Time',
  ToTime: 'To Time',
  'OT Hours': 'Hrs',
  Reason: 'Reason',
  Status: 'Status',
  Approver: 'Approver',
  PayPeriod: 'Pay Period',
};

export const LEAVE_STATUS_BADGE_STYLES = {
  Approved: {
    backgroundColor: '#ECFDF3',
    borderColor: '#ABEFC6',
    fontColor: '#067647',
    dotColor: '#17B26A',
  },
  Rejected: {
    backgroundColor: '#FEF3F2',
    borderColor: '#FECDCA',
    fontColor: '#B42318',
    dotColor: '#F04438',
  },
  Pending: {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
    dotColor: '#2E90FA',
  },
};
